import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M16 4.525v14.948', key: 'bgoxo0' }],
  ['path', { d: 'M20 3A17 17 0 0 1 4 3', key: '1djemw' }],
  ['path', { d: 'M4 21a17 17 0 0 1 16 0', key: 'onoyo7' }],
  ['path', { d: 'M8 4.525v14.948', key: 'u5iyof' }],
];

/**
 * @component @name ZodiacGemini
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgNC41MjV2MTQuOTQ4IiAvPgogIDxwYXRoIGQ9Ik0yMCAzQTE3IDE3IDAgMCAxIDQgMyIgLz4KICA8cGF0aCBkPSJNNCAyMWExNyAxNyAwIDAgMSAxNiAwIiAvPgogIDxwYXRoIGQ9Ik04IDQuNTI1djE0Ljk0OCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/zodiac-gemini
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ZodiacGemini = createLucideIcon('zodiac-gemini', __iconNode);

export default ZodiacGemini;
